import { Divider, Group, Stack } from "@mantine/core";
import LeftLinks from "./LeftLinks";
import { Outlet } from "react-router-dom";

const Settings = () => {
  return (
    <Group wrap="nowrap" flex={1} h={"100%"} gap={32} align="start">
      <LeftLinks />

      <Divider orientation="vertical" />

      <Stack h={"100%"} flex={1} pt={16}>
        <Outlet />
      </Stack>
    </Group>
  );
};

export default Settings;
